import React from 'react'
import { FormattedMessage } from 'react-intl'

import Appbar from '@components/Appbar'
import Footer from '@components/NewFooter'

import { brokerThankYou } from '@assets'
import useInternationalization from '@hooks/useInternationalization'
import * as Style from './Broker.style'

export default function Broker() {
  const { country } = useInternationalization()

  const employeeNumberThreshold = country === 'uk' ? 100 : 1000

  function close() {
    window.open(`https://site.gympass.com/${country}/broker`, '_self')
  }

  return (
    <Style.BrokerWrapper>
      <Appbar />

      <Style.BrokerContainer>
        <Style.Main>
          <Style.Image src={brokerThankYou} />
          <Style.Title>
            <FormattedMessage id="smb_acquisition_thankyou.broker.title" />
          </Style.Title>

          <Style.Subtitle>
            <FormattedMessage
              id="smb_acquisition_thankyou.broker.subtitle"
              values={{
                strong: (...chunks) => <strong>{chunks}</strong>,
                employeeNumberThreshold,
              }}
            />
          </Style.Subtitle>
          <Style.ButtonWrapper>
            <Style.Button onClick={close}>
              <Style.ButtonText>
                <FormattedMessage id="smb_acquisition_thankyou.above_threshold.call_to_action.ok_close" />
              </Style.ButtonText>
            </Style.Button>
          </Style.ButtonWrapper>
        </Style.Main>
      </Style.BrokerContainer>

      <Footer showFooterImage={false} />
    </Style.BrokerWrapper>
  )
}
